import IconBase from './IconBase'

interface PropsType {
  width?: string | number
  height?: string | number
  className?: string
}

const PopupIcon = (props: PropsType) => {
  const { width, height, className } = props
  return (
    <IconBase width={width} height={height} className={className}>
      <path d="M595 490H129v-50h416V100h50v390z" />
      <path d="M419 50v270H50V50h369m50-50H0v370h469V0z" />
    </IconBase>
  )
}

export default PopupIcon
